import { title } from "@/config";
const Layout = (resolve) => require(["@/views/layout/main"], resolve);
const appMainLayout = (resolve) => require(["@/views/layout/appMain"], resolve);
const ParentView = (resolve) => require(["@/components/parentView/index"], resolve);

/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * query: '{"id": 1, "name": "ry"}' // 访问路由的默认传递参数
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标，对应路径src/assets/icons/svg
    breadcrumb: false               // 如果设置为false，则不会在breadcrumb面包屑中显示
    activeMenu: '/system/user'      // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */

// 公共路由
export const constantRoutes = [
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path(.*)",
        component: (resolve) => require(["@/components/redirect"], resolve)
      }
    ]
  },
  {
    path: "/login",
    meta: {
      title: title
    },
    hidden: true,
    component: (resolve) => require(["@/components/login/index"], resolve)
  },
  {
    path: "/loginSuccess",
    meta: {
      title: "登录中"
    },
    hidden: true,
    component: (resolve) => require(["@/components/login/loginSuccess"], resolve)
  },
  {
    path: "/loginFail",
    meta: {
      title: "登录失败"
    },
    hidden: true,
    component: (resolve) => require(["@/components/login/loginFail"], resolve)
  },
  {
    path: "/404",
    meta: {
      title: "404-页面不存在"
    },
    hidden: true,
    component: (resolve) => require(["@/components/error-page/404"], resolve),
  },
  {
    path: "/",
    redirect: "home",
    hidden: true,
  },
  {
    path: "/home",
    name: "Home",
    hidden: false,
    component: (resolve) => require(["@/views/home/index"], resolve),
    meta: {
      title: "首页",
    },
  },
  // 主视口内容
  {
    path: "/views",
    component: Layout,
    hidden: true,
    headerNav: true,
    meta: {
      breadcrumb: [
        { title: "首页", path: "/" }
      ]
    },
    children: [
      {
        path: "search",
        name: "Search",
        hidden: true,
        meta: {
          title: "搜索列表",
          breadcrumb: [
            { title: "搜索列表" }
          ]
        },
        component: (resolve) => require(["@/views/search/index"], resolve)
      },
      // 搜索列表 -> 详情
      {
        path: "details/:id",
        name: "Details",
        hidden: true,
        meta: {
          title: "详情",
          breadcrumb: [
            { title: "搜索列表", path: "/views/search" },
            { title: "详情" }
          ]
        },
        component: (resolve) => require(["@/views/details/index"], resolve)
      },
      // 首页 -> 详情
      {
        path: "homeDetails/:id",
        name: "HomeDetails",
        hidden: true,
        meta: {
          title: "详情",
          breadcrumb: [
            { title: "详情" }
          ]
        },
        component: (resolve) => require(["@/views/details/index"], resolve)
      },
      // 首页 -> 详情
      {
        path: "homeExpertDetails/:id",
        name: "HomeExpertDetails",
        hidden: true,
        meta: {
          title: "详情",
          breadcrumb: [
            { title: "详情" }
          ]
        },
        component: (resolve) => require(["@/views/details/expertDetail"], resolve)
      },

      // 页眉导航下的二级路由页面
      {
        path: "agency",
        name: "Agency",
        hidden: false,
        redirect: "agency/brief",
        component: appMainLayout,
        meta: {
          title: "机构概况",
        },
        children: [
          {
            path: "brief",
            name: "Brief",
            hidden: false,
            component: (resolve) => require(["@/views/agency/brief"], resolve),
            meta: {
              title: "研究中心简介",
            },
          },
          {
            path: "workReport",
            name: "WorkReport",
            hidden: false,
            redirect: "/views/agency/workReport/2024",
            component: (resolve) => require(["@/components/parentView"], resolve),
            meta: {
              title: "年度工作报告",
            },
            children: [
              {
                path: "2024",
                name: "Report2024",
                hidden: false,
                component: (resolve) => require(["@/views/agency/workReport/2024"], resolve),
                meta: {
                  title: "2024年度",
                }
              },
              {
                path: "2023",
                name: "Report2023",
                hidden: false,
                component: (resolve) => require(["@/views/agency/workReport/2023"], resolve),
                meta: {
                  title: "2023年度",
                }
              }
            ]
          },
          {
            path: "xuewei",
            name: "Xuewei",
            hidden: false,
            component: (resolve) => require(["@/views/agency/xuewei"], resolve),
            meta: {
              title: "学术委员会",
            },
          },
          {
            path: "expert",
            name: "Expert",
            hidden: false,
            redirect: "/views/agency/expert/expert1",
            component: (resolve) => require(["@/views/agency/expert"], resolve),
            meta: {
              title: "专家学者",
            },
            children: [
              {
                path: "expert1",
                name: "Expert1",
                hidden: false,
                component: (resolve) => require(["@/views/agency/expert/list"], resolve),
                meta: {
                  title: "本院学者",
                },
              },
              {
                path: "expert2",
                name: "Expert2",
                hidden: false,
                component: (resolve) => require(["@/views/agency/expert/list"], resolve),
                meta: {
                  title: "特聘专家",
                },
              },
              {
                path: "expert3",
                name: "Expert3",
                hidden: false,
                component: (resolve) => require(["@/views/agency/expert/list"], resolve),
                meta: {
                  title: "双聘研究员",
                },
              },
              {
                path: "expert4",
                name: "Expert4",
                hidden: false,
                component: (resolve) => require(["@/views/agency/expert/list"], resolve),
                meta: {
                  title: "兼职研究员",
                },
              },
            ]
          },
          {
            path: "contact",
            name: "Contact",
            hidden: false,
            component: (resolve) => require(["@/views/agency/contact"], resolve),
            meta: {
              title: "联系我们",
            },
          }
        ]
      },
      // 专家学者-本院学者-详情
      {
        path: "expert1Details/:id",
        name: "Expert1Details",
        hidden: true,
        meta: {
          title: "本院学者详情",
          breadcrumb: [
            { title: "机构概况", path: "/views/agency" },
            { title: "专家学者", path: "/views/agency/expert" },
            { title: "本院学者", path: "/views/agency/expert/expert1" },
            { title: "详情" },
          ]
        },
        component: (resolve) => require(["@/views/details/expertDetail"], resolve)
      },
      // 专家学者-特聘专家-详情
      {
        path: "expert2Details/:id",
        name: "Expert2Details",
        hidden: true,
        meta: {
          title: "特聘专家详情",
          breadcrumb: [
            { title: "机构概况", path: "/views/agency" },
            { title: "专家学者", path: "/views/agency/expert" },
            { title: "特聘专家", path: "/views/agency/expert/expert2" },
            { title: "详情" },
          ]
        },
        component: (resolve) => require(["@/views/details/expertDetail"], resolve)
      },
      // 专家学者-双聘研究员-详情
      {
        path: "expert3Details/:id",
        name: "Expert3Details",
        hidden: true,
        meta: {
          title: "双聘研究员详情",
          breadcrumb: [
            { title: "机构概况", path: "/views/agency" },
            { title: "专家学者", path: "/views/agency/expert" },
            { title: "双聘研究员", path: "/views/agency/expert/expert3" },
            { title: "详情" },
          ]
        },
        component: (resolve) => require(["@/views/details/expertDetail"], resolve)
      },
      // 专家学者-兼职研究员-详情
      {
        path: "expert4Details/:id",
        name: "Expert4Details",
        hidden: true,
        meta: {
          title: "兼职研究员详情",
          breadcrumb: [
            { title: "机构概况", path: "/views/agency" },
            { title: "专家学者", path: "/views/agency/expert" },
            { title: "兼职研究员", path: "/views/agency/expert/expert4" },
            { title: "详情" },
          ]
        },
        component: (resolve) => require(["@/views/details/expertDetail"], resolve)
      },

      // 学术委员会
      {
        path: "xueweiDetails/:id",
        name: "XueweiDetails",
        hidden: true,
        meta: {
          title: "学术委员会详情",
          breadcrumb: [
            { title: "机构概况", path: "/views/agency" },
            { title: "学术委员会", path: "/views/agency/xuewei" },
            { title: "详情" },
          ]
        },
        component: (resolve) => require(["@/views/details/expertDetail"], resolve)
      },

      // 新闻公告
      {
        path: "news",
        name: "News",
        hidden: false,
        redirect: "news/lastNews",
        component: appMainLayout,
        meta: {
          title: "新闻公告",
        },
        children: [
          {
            path: "lastNews",
            name: "LastNews",
            hidden: false,
            component: (resolve) => require(["@/views/news/lastNews"], resolve),
            meta: {
              title: "最新动态",
            },
          },
          {
            path: "notice",
            name: "Notice",
            hidden: false,
            component: (resolve) => require(["@/views/news/notice"], resolve),
            meta: {
              title: "通知公告",
            },
          }
        ]
      },
      // 最新动态-详情
      {
        path: "lastNewsDetails/:id",
        name: "LastNewsDetails",
        hidden: true,
        meta: {
          title: "最新动态详情",
          breadcrumb: [
            { title: "新闻公告", path: "/views/news" },
            { title: "最新动态", path: "/views/news/lastNews" },
            { title: "详情" },
          ]
        },
        component: (resolve) => require(["@/views/details/index"], resolve)
      },
      // 通知公告-详情
      {
        path: "noticeDetails/:id",
        name: "NoticeDetails",
        hidden: true,
        meta: {
          title: "通知公告详情",
          breadcrumb: [
            { title: "新闻公告", path: "/views/news" },
            { title: "通知公告", path: "/views/news/notice" },
            { title: "详情" },
          ]
        },
        component: (resolve) => require(["@/views/details/index"], resolve)
      },

      // 学术活动
      {
        path: "activity",
        name: "Activity",
        hidden: false,
        redirect: "activity/yugao",
        component: appMainLayout,
        meta: {
          title: "学术活动",
        },
        children: [
          {
            path: "yugao",
            name: "Yugao",
            hidden: false,
            component: (resolve) => require(["@/views/activity/yugao"], resolve),
            meta: {
              title: "活动预告",
            },
          },
          {
            path: "qianyan",
            name: "Qianyan",
            hidden: false,
            component: (resolve) => require(["@/views/activity/qianyan"], resolve),
            meta: {
              title: "前沿观点",
            },
          }
        ]
      },
      // 活动预告-详情
      {
        path: "yugaoDetails/:id",
        name: "YugaoDetails",
        hidden: true,
        meta: {
          title: "活动预告详情",
          breadcrumb: [
            { title: "学术活动", path: "/views/activity" },
            { title: "活动预告", path: "/views/activity/yugao" },
            { title: "详情" },
          ]
        },
        component: (resolve) => require(["@/views/details/index"], resolve)
      },
      // 前沿观点-详情
      {
        path: "qianyanDetails/:id",
        name: "QianyanDetails",
        hidden: true,
        meta: {
          title: "前沿观点详情",
          breadcrumb: [
            { title: "学术活动", path: "/views/activity" },
            { title: "前沿观点", path: "/views/activity/qianyan" },
            { title: "详情" },
          ]
        },
        component: (resolve) => require(["@/views/details/index"], resolve)
      },

      // 学术研究
      {
        path: "study",
        name: "Study",
        hidden: false,
        redirect: "study/sudi",
        component: appMainLayout,
        meta: {
          title: "学术研究",
        },
        children: [
          {
            path: "sudi",
            name: "Sudi",
            hidden: false,
            component: (resolve) => require(["@/views/study/sudi"], resolve),
            meta: {
              title: "学术著作",
            },
          },
          {
            path: "qikan",
            name: "Qikan",
            hidden: false,
            component: (resolve) => require(["@/views/study/qikan"], resolve),
            meta: {
              title: "期刊论文",
            },
          },
          {
            path: "subjectProject",
            name: "SubjectProject",
            hidden: false,
            redirect: "/views/study/subjectProject/subpro1",
            component: (resolve) => require(["@/views/study/subjectProject"], resolve),
            meta: {
              title: "课题项目",
            },
            children: [
              {
                path: "subpro1",
                name: "Subpro1",
                hidden: false,
                component: (resolve) => require(["@/views/study/subjectProject/list"], resolve),
                meta: {
                  title: "国家级课题",
                },
              },
              {
                path: "subpro2",
                name: "Subpro2",
                hidden: false,
                component: (resolve) => require(["@/views/study/subjectProject/list"], resolve),
                meta: {
                  title: "省部级课题",
                },
              },
              {
                path: "subpro3",
                name: "Subpro3",
                hidden: false,
                component: (resolve) => require(["@/views/study/subjectProject/list"], resolve),
                meta: {
                  title: "博士后项目",
                },
              },
            ]
          },
          {
            path: "rongyu",
            name: "Rongyu",
            hidden: false,
            component: (resolve) => require(["@/views/study/rongyu"], resolve),
            meta: {
              title: "荣誉奖项",
            },
          },
        ]
      },
      // 学术著作-详情
      {
        path: "sudiDetails/:id",
        name: "SudiDetails",
        hidden: true,
        meta: {
          title: "学术著作详情",
          breadcrumb: [
            { title: "学术研究", path: "/views/study" },
            { title: "学术著作", path: "/views/study/sudi" },
            { title: "详情" },
          ]
        },
        component: (resolve) => require(["@/views/details/index"], resolve)
      },
      // 期刊论文-详情
      {
        path: "qikanDetails/:id",
        name: "QikanDetails",
        hidden: true,
        meta: {
          title: "期刊论文详情",
          breadcrumb: [
            { title: "学术研究", path: "/views/study" },
            { title: "期刊论文", path: "/views/study/qikan" },
            { title: "详情" },
          ]
        },
        component: (resolve) => require(["@/views/details/index"], resolve)
      },
      // 课题项目-国家级课题-详情
      {
        path: "subpro1Details/:id",
        name: "Subpro1Details",
        hidden: true,
        meta: {
          title: "国家级课题详情",
          breadcrumb: [
            { title: "学术研究", path: "/views/study" },
            { title: "课题项目", path: "/views/study/subjectProject" },
            { title: "国家级课题", path: "/views/study/subjectProject/subpro1" },
            { title: "详情" },
          ]
        },
        component: (resolve) => require(["@/views/details/index"], resolve)
      },
      // 课题项目-省部级课题-详情
      {
        path: "subpro2Details/:id",
        name: "Subpro2Details",
        hidden: true,
        meta: {
          title: "省部级课题详情",
          breadcrumb: [
            { title: "学术研究", path: "/views/study" },
            { title: "课题项目", path: "/views/study/subjectProject" },
            { title: "省部级课题", path: "/views/study/subjectProject/subpro2" },
            { title: "详情" },
          ]
        },
        component: (resolve) => require(["@/views/details/index"], resolve)
      },
      // 课题项目-博士后项目-详情
      {
        path: "subpro3Details/:id",
        name: "Subpro3Details",
        hidden: true,
        meta: {
          title: "博士后项目详情",
          breadcrumb: [
            { title: "学术研究", path: "/views/study" },
            { title: "课题项目", path: "/views/study/subjectProject" },
            { title: "博士后项目", path: "/views/study/subjectProject/subpro3" },
            { title: "详情" },
          ]
        },
        component: (resolve) => require(["@/views/details/index"], resolve)
      },
      // 荣誉奖项-详情
      {
        path: "rongyuDetails/:id",
        name: "RongyuDetails",
        hidden: true,
        meta: {
          title: "期刊论文详情",
          breadcrumb: [
            { title: "学术研究", path: "/views/study" },
            { title: "荣誉奖项", path: "/views/study/rongyu" },
            { title: "详情" },
          ]
        },
        component: (resolve) => require(["@/views/details/index"], resolve)
      },

      // 人才培养
      {
        path: "personnelTraining",
        name: "PersonnelTraining",
        redirect: "/",
        hidden: false,
        meta: {
          title: "人才培养",
        },
        component: ParentView,
        children: [
          {
            path: "training1Details",
            name: "Training1Details",
            hidden: false,
            component: (resolve) => require(["@/views/details/trainingDetail"], resolve),
            meta: {
              title: "博士后培养",
              needRefresh: true
            },
          },
          {
            path: "training2Details",
            name: "Training2Details",
            hidden: false,
            component: (resolve) => require(["@/views/details/trainingDetail"], resolve),
            meta: {
              title: "博士生培养",
              needRefresh: true
            },
          },
          {
            path: "training3Details",
            name: "Training3Details",
            hidden: false,
            component: (resolve) => require(["@/views/details/trainingDetail"], resolve),
            meta: {
              title: "硕士生培养",
              needRefresh: true
            },
          },
          // {
          //   path: "training4Details",
          //   name: "Training4Details",
          //   hidden: false,
          //   component: (resolve) => require(["@/views/details/trainingDetail"], resolve),
          //   meta: {
          //     title: "开设课程",
          //     needRefresh: true
          //   },
          // },
          {
            path: "training4",
            name: "Training4",
            hidden: false,
            component: (resolve) => require(["@/views/training/kecheng"], resolve),
            meta: {
              title: "开设课程",
            },
          }
        ]
      },
      // 开设课程-详情
      {
        path: "training4Details/:id",
        name: "Training4Details",
        hidden: true,
        meta: {
          title: "开设课程详情",
          breadcrumb: [
            { title: "人才培养", path: "/" },
            { title: "开设课程", path: "/views/personnelTraining/training4" },
            { title: "详情" },
          ]
        },
        component: (resolve) => require(["@/views/details/trainingDetail"], resolve)
      },

      // 中国故事重大项目
      {
        path: "chinaStory",
        name: "ChinaStory",
        hidden: false,
        redirect: "chinaStory/brief",
        component: appMainLayout,
        meta: {
          title: "“中国故事”重大项目",
        },
        children: [
          {
            path: "brief",
            name: "ChinaStoryBrief",
            hidden: false,
            component: (resolve) => require(["@/views/chinaStory/brief"], resolve),
            meta: {
              title: "项目简介",
            },
          },
          {
            path: "dashiji",
            name: "Dashiji",
            hidden: false,
            component: (resolve) => require(["@/views/chinaStory/dashiji"], resolve),
            meta: {
              title: "教育部重大课题大事记",
            },
          },
          {
            path: "baodao",
            name: "Baodao",
            hidden: false,
            component: (resolve) => require(["@/views/chinaStory/baodao"], resolve),
            meta: {
              title: "新闻报道",
            },
          },
          {
            path: "chengguo",
            name: "Chengguo",
            hidden: false,
            component: (resolve) => require(["@/views/chinaStory/chengguo"], resolve),
            meta: {
              title: "项目成果",
            },
          }
        ]
      },
      // 教育部重大课题大事记-详情
      {
        path: "dashijiDetails/:id",
        name: "DashijiDetails",
        hidden: true,
        meta: {
          title: "教育部重大课题大事记详情",
          breadcrumb: [
            { title: "“中国故事”重大项目", path: "/views/chinaStory" },
            { title: "教育部重大课题大事记", path: "/views/chinaStory/dashiji" },
            { title: "详情" },
          ]
        },
        component: (resolve) => require(["@/views/details/index"], resolve)
      },
      // 新闻报道-详情
      {
        path: "baodaoDetails/:id",
        name: "BaodaoDetails",
        hidden: true,
        meta: {
          title: "新闻报道详情",
          breadcrumb: [
            { title: "“中国故事”重大项目", path: "/views/chinaStory" },
            { title: "新闻报道", path: "/views/chinaStory/baodao" },
            { title: "详情" },
          ]
        },
        component: (resolve) => require(["@/views/details/index"], resolve)
      },
      // 项目成果-详情
      {
        path: "chengguoDetails/:id",
        name: "ChengguoDetails",
        hidden: true,
        meta: {
          title: "项目成果详情",
          breadcrumb: [
            { title: "“中国故事”重大项目", path: "/views/chinaStory" },
            { title: "项目成果", path: "/views/chinaStory/chengguo" },
            { title: "详情" },
          ]
        },
        component: (resolve) => require(["@/views/details/index"], resolve)
      },
    ]
  },

  { path: "*", redirect: "/404", hidden: true }
];

export const routes = [
  ...constantRoutes,
];
